import { textVariant } from './Text'
import { SliderComposition } from '@codeleap/web'
import { createStyles } from '@codeleap/styles'
import { StyleRegistry } from '../styles'

const createSliderVariant = createStyles<SliderComposition>

export const SliderStyles = {
  default: createSliderVariant((theme) => {
    const thumbSize = theme.size.small
    const trackHeight = 4
    return {
      wrapper: {
        ...theme.presets.column,
      },
      innerWrapper: {
        ...theme.presets.column,
      },
      thumb: {
        height: thumbSize,
        width: thumbSize,
        backgroundColor: theme.baseColors.primarySolid800,
        display: 'block',
        boxShadow: `0 1px 3px ${theme.baseColors.neutralSolid500}`,
        borderRadius: theme.radius.infinite,
        cursor: 'pointer',
      },
      'thumb:disabled': {
        cursor: 'not-allowed',
        backgroundColor: theme.baseColors.neutralSolid300,
      },
      selectedTrack: {
        backgroundColor: theme.baseColors.primarySolid800,
        position: 'absolute',
        borderRadius: theme.radius.infinite,
        height: '100%',
      },
      track: {
        position: 'relative',
        flexGrow: 1,
        borderRadius: theme.radius.infinite,
        backgroundColor: theme.baseColors.primarySolid100,
        height: trackHeight,
      },
      label: {
        ...textVariant('h5'),
        color: theme.baseColors.neutralSolid800,
        marginBottom: theme.spacing.value(0),
      },
      description: {
        ...textVariant('p3'),
        color: theme.baseColors.neutralSolid800,
        marginBottom: theme.spacing.value(0),
      },
      labelRow: {
        ...theme.presets.row,
        ...theme.presets.alignCenter,
        ...theme.presets.justifySpaceBetween,
        ...theme.spacing.marginBottom(2),
      },
      sliderContainer: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        userSelect: 'none',
        touchAction: 'none',
      },
      trackMark: {
        ...textVariant('p5'),
        color: theme.baseColors.neutralSolid500,
        textAlign: 'center',
      },
      firstTrackMark: {
        textAlign: 'left',
      },
      lastTrackMark: {
        textAlign: 'right',
      },
      trackMarkWrapper: {
        width: '100%',
        height: 'auto',
        ...theme.presets.row,
        ...theme.presets.justifySpaceBetween,
        marginTop: theme.spacing.value(2.5),
        position: 'relative',
      },
      'trackMark:disabled': {
        color: theme.baseColors.neutralSolid500,
      },
      'label:disabled': {
        color: theme.baseColors.neutralSolid500,
      },
      'description:disabled': {
        color: theme.baseColors.neutralSolid500,
      },
      'selectedTrack:disabled': {
        backgroundColor: theme.baseColors.neutralSolid500,
      },
      errorMessage: {
        ...textVariant('p4'),
        color: theme.baseColors.redSolid400,
        ...theme.spacing.marginTop(1),
      },
    }
  }),
}

StyleRegistry.registerVariants('Slider', SliderStyles)
